
export enum MailType {
    INFO,
    CASE,
    CASE_UPDATE,
    RANK_UP_EMAIL,
}